import instObj from '@/backend/axios-instances'

const resource = "/order"
const instance = instObj.baseInstance

export default {
  get(orderId, parameters) {
    return instance.get(`${resource}/${orderId}`, { params: parameters });
  },
  put(orderId, data, parameters) {
    // need project_id as a parameter
    return instance.put(`${resource}/${orderId}`, data, { params: parameters });
  },
  delete(orderId) {
    return instance.delete(`${resource}/${orderId}`);
  }
}
